import type { IJsonValue } from '@/globalTypes';

/**
 * Utility function to send postMessage to the native shell.
 * @param type - The type of message to send to the native shell.
 * @param payload - The payload to send to the native shell.
 */
export const sendMessageToNative = <T extends IJsonValue>(type: string, payload?: T) => {
  try {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type, payload }));
    }
  } catch (error) {
    console.error('Error sending message:', error);
  }
};

/**
 * Request camera access from the native shell.
 */
export const requestCameraAccess = () => {
  sendMessageToNative('CAMERA_ACCESS_REQUEST');
};

/**
 * Request photo capture from the native camera.
 */
export const requestPhotoCapture = () => {
  sendMessageToNative('CAMERA_CAPTURE_REQUEST');
};

/**
 * Request camera close on the native shell.
 */
export const requestCameraClose = () => {
  sendMessageToNative('CAMERA_CLOSE_REQUEST');
};
